<template>
  <v-card :elevation="1"
          rounded="lg"
          class="pa-4"
          style="height:100%; width:100%; overflow: scroll">
    <div class="font-weight-bold text-lg">
      {{ conf.title }}
      <span
          class="font-weight-medium grey--text text--lighten-1 ml-2"> (paiement sous 1 mois)</span>
    </div>
    <v-data-table class="mt-3"
                  :loading="items.length < 1 && loading"
                  :headers="headers"
                  :items="items"
                  item-key="bookingId"
                  hide-default-footer
                  disable-pagination
                  v-if="items.length > 0"
    >
      <template v-slot:body="{ items }">
        <tbody>
        <tr
            v-for="(item, index) in items"
            :key="index"
        >
          <td class="">{{ item.supplierName }}</td>
          <td class="">{{ _parseAndFormatDate(item.paymentDate,'yyyy-MM-dd','dd/MM/yyyy') }}</td>
          <td class="">
              <v-chip @click="openBooking(item)"
                              label
                              flat
                              small
                              outlined
                              class="grey lighten-2 blue--text text--lighten-2 "
                      >
                        <v-icon small class="mr-2">mdi-open-in-new</v-icon>
              {{ item.bookingId }}
                      </v-chip>
          </td>
          <td class="">
            <div class="d-flex flex-column red--text">
              {{_formatCurrency(item.amount , "EUR") }}
            </div>
          </td>

        </tr>
        </tbody>

      </template>


    </v-data-table>
  </v-card>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import {get, post} from "@/utils/api";
import {addDays} from "date-fns";
// Détails CA par site
export default {
  name: "NextSupplierPaymentTable",

  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: "Fournisseur",
          value: "supplierName",
          align: "left",
          sortable: false,
        },
          {
          text: "Date départ",
          value: "Date paiement",
          align: "left",
          sortable: false,
        },
        {
          text: "Dossier",
          value: "bookingId",
          align: "left",
          sortable: false,
        },
        {
          text: "Reste à payer",
          value: "remainPay",
          align: "left",
          sortable: false,
        },
        ],
      url: `/api/widget/bookings/supplier-payment`,
      totaux: {},
      totauxPast: {}
    }
  },
  props: {
    form: {type: Object, required: true},
    conf: {type: Object, required: false, default: null}
  },
  created() {
    this.init()
    EventBus.$on('searchDashboard', () => this.init());
  },
  computed: {},
  methods: {
    init() {
      const body = {
        startDateAct: this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateAct:  this._formatDate(new Date(), 'yyyy-MM-dd'),
        startDateOld: this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateOld:  this._formatDate(new Date(), 'yyyy-MM-dd'),
        destinations: [],
        sites: [],
        commercialIds: [],
        allAgencies: false,
        bookingStatus: null
      }
      this.items = []
      post(this.url, body, {"Content-Type": "application/json"})
          .json(r => {
            this.items = r
          })
    },
    openBooking(item){
      let route = this.$router.resolve({
          name: "Booking",
          params: {id: item.bookingId},
        });
        window.open(route.href, "_blank");

    },
    sum(accumulator, a) {
      return accumulator + a;
    },

    getTooltipPeriod(duration) {
      if (this.items.length > 0) {
        if (duration == 'day') {

          return `Le ${this._formatDate(new Date(this.items[0][duration].startPeriod), 'dd MMM yyyy')}
           comparé au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'dd MMM yyyy')}`


        } else {
          return `
                Période du ${this._formatDate(new Date(this.items[0][duration].startPeriod), ' EEE dd MMM')}
                au ${this._formatDate(new Date(this.items[0][duration].endPeriod), 'EEE dd MMM yyyy')}, <br/>
                par rapport au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'EEE dd MMM')}
                jusqu'au ${this._formatDate(new Date(this.items[0][duration].oldEndPeriod), 'EEE dd MMM yyyy')}`

        }
      } else {
        return 'pas de données'
      }
    },

  },

}
</script>


